<template>
  <v-container class="text-left site-content-crowded px-8">
    <v-sheet class="d-flex align-center ramp-location-filter">
      <v-col
        cols="12"
        class="py-2"
      >
        <v-icon class="mdi mdi-map-marker mr-3 no-mobile"></v-icon>
        <v-btn-toggle
          v-model="selectedLocation"
          shaped
          variant="text"
          selected-class="ramp-location-toggle"
          mandatory
        >
          <v-btn @click="locationFilter('all')" value="all" class="loc-btn">
            All
          </v-btn>
          <v-btn v-for="location in locations"  class="loc-btn"
          :key="location.id" :value="location.id" @click="locationFilter(location.id)">
            {{ location.name }}
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-sheet>
  </v-container>
  <v-container class="text-left site-content-crowded px-8">
    <v-row no-gutters v-if="jobs.length">
      <v-col xl="3" md="3" :class="selectionOnMobile ? 'no-mobile' : 'normal'">
        <v-card
          v-for="job in jobs"
          :key="job.id"
          :ref="job.id"
          :class="{ 'ramp-job-items-active': selectsJobItem(job.id) }"
          @click="clickedJobItem(job.id);selectionOnMobile=true;"
          class="mb-2 pa-2 rounded ramp-job-items"
        >
          <v-card-subtitle class="ramp-job-title">
            {{ job.title }}
            <span v-if="job.userAppliedThisJob" class="alreadyApplied">
              <v-icon class="mdi mdi-briefcase-check text-info"></v-icon>
              <v-tooltip
                activator="parent"
                location="top"
              >Already applied for this position.</v-tooltip>
            </span>
          </v-card-subtitle>
          <v-card-text>
            <div class="ramp-job-description-icons">
                <v-icon class="mdi mdi-map-marker"></v-icon> {{ job.territory.name }}
            </div>
            <div class="ramp-job-description-content">
              {{ job.sub_title }}
            </div>
          </v-card-text>
        </v-card>
        <DataPagination
        :totalItemsForPages="totalItemsForPages"
        :perPage="perPage"
        :visiblePages="3"
        @paginationPageUpdate="updatePage"
        ></DataPagination>
        <v-overlay
          v-model="listLoader"
          class="align-center justify-center"
        >
        <div>
          <v-progress-circular
            indeterminate
            color="blue"
            :size="113"
            :width="7"
          ></v-progress-circular>
          <p class="text-white">
            Fetching Jobs
          </p>
        </div>
        </v-overlay>
      </v-col>
      <v-col xl="9" md="9" :class="!selectionOnMobile ? 'no-mobile' : 'normal'">
        <v-card
          class="ml-4 mb-10 pa-5 rounded-xl"
        >
          <v-card-subtitle class="ramp-job-title">
            {{ selectedJobDetails.title }}
            <a :href="jobItemLinks(selectedJobDetails.slug)" @click="setLocalSlug(selectedJobDetails.slug, selectedJobDetails.id)" target="_blank" class="float-right ramp-job-new-tab no-mobile">
              Apply for this Job
              <v-icon class="mdi mdi-open-in-new"></v-icon>
            </a>
          </v-card-subtitle>
          <v-card-text>
            <div class="ramp-job-description-icons">
                <v-icon class="mdi mdi-map-marker"></v-icon> {{ selectedJobDetails.territory?.name }}
                <span class="float-right ramp-job-shares">
                  <b class="mr-2">SHARE</b>
                  <!-- <v-icon class="mdi mdi-share-variant-outline mr-1 shareButtons" @click="shareJob('shares')"></!-->
                  <v-icon class="mdi mdi-content-copy mr-1 shareButtons" @click="shareJob('copy',selectedJobDetails.slug)"></v-icon>
                  <!-- <v-icon class="mdi mdi-email-outline mr-1 shareButtons" @click="shareJob('mail',selectedJobDetails.slug)"></v-icon> -->
                </span>
            </div>
            <div class="ramp-job-description-main-content">
              <div id="main-content">
                <div class="form-generated">
                  <div v-html="layout"></div>
                </div>
            </div>
            </div>
            <div class="text-center">
              <v-btn block class="mb-1" :href="jobItemLinks(selectedJobDetails.slug)" @click="setLocalSlug(selectedJobDetails.slug, selectedJobDetails.id)" color="info"><v-icon class="mdi mdi-briefcase"></v-icon> Apply for this Job</v-btn>
              <v-btn block color="warning" class="mobile-only" @click="selectionOnMobile=false">
                <v-icon class="mdi mdi-arrow-left"></v-icon> Back to List
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters v-else>
      <v-col xl="12" md="12" class="text-center ma-10 pa-10">
        <div v-if="displayLoader">
          <v-progress-circular
            indeterminate
            color="blue-grey"
            :size="113"
            :width="7"
          ></v-progress-circular>
          <p class="text-grey">
            Checking for Job Openings
          </p>
        </div>
        <div v-else>
          <h1>
            <v-icon class="mdi mdi-emoticon-sad-outline"></v-icon>
          </h1>
          <h3>
            Sorry, there are job openings as of the moment.
          </h3>
          <p class="text-grey">
            Please do: try a different location or visit this page another time.
          </p>
        </div>
      </v-col>
    </v-row>
  </v-container>
  <v-overlay
    :model-value="shareModal"
    :disabled="true"
    :persistent="true"
    class="align-center justify-center"
  >
    <v-card class="overlay-content pa-5" width="400">
      <div v-if="shareType === 'copy'">
        <h4>
          Copy Url:
          <v-icon class="mdi mdi-close float-right" @click="shareModal=false"></v-icon>
        </h4>
        <v-text-field class="pt-2 pb-2 mt-5" :value="shareLink" density="compact">
          <template v-slot:append>
            <v-btn size="xl" color="info" @click="copyToClipboard()">
              <v-icon class="mdi mdi-content-copy"></v-icon>
            </v-btn>
          </template>
        </v-text-field>
        <div v-if="shareResult" class="text-center text-success mb-2">
          <v-icon class="mdi mdi-content-copy"></v-icon> Copied to Clipboard
        </div>
      </div>
      <div v-else-if="shareType === 'mail'">
        <h4>
          Send to E-mail:
          <v-icon class="mdi mdi-close float-right" @click="shareModal=false"></v-icon>
        </h4>
        <v-text-field label="Name" v-model="name" required></v-text-field>
        <v-text-field label="E-mail" v-model="email" required></v-text-field>
        <v-btn color="light-blue" block @click="sendToEmail()" :loading="emailLoader">
          <v-icon class="mdi mdi-email-arrow-right"></v-icon> Send
        </v-btn>
        <div v-if="shareResult" class="text-center mt-2">
          <span v-if="shareResult === 'emailed'" class="text-success"><v-icon class="mdi mdi-email-arrow-right"></v-icon> E-mail Sent </span>
          <span v-else class="text-red"><v-icon class="mdi mdi-alert"></v-icon> {{ shareResult }}</span>
        </div>
      </div>
    </v-card>
  </v-overlay>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DataPagination from "../components/DataPagination.vue";
import { Item } from "@directus/sdk";
export default defineComponent({
  name: "RAMP - Recruiting",
  components: {
    DataPagination: DataPagination,
  },
  data() {
    return {
      locations: [] as Item[],
      jobs: [] as Item[],
      userJobApplications: [] as Item[],
      user: {} as Item,
      jobPagination: 1,
      selectedJobItem: '',
      selectedJobDetails: {} as Item,
      displayLoader: true,
      listLoader: true,
      activePage: 1, // Active Page
      totalItemsForPages: 0, // Total Items
      perPage: 10, // Number of items to show per page,
      userSigned: false,
      shareModal: false,
      shareType: 'copy',
      shareLink: '',
      shareResult: '',
      name: '',
      email: '',
      emailLoader: false,
      selectedLocation: 'all',
      slug: '' as string,
      editorTextTemplate: {
        jobTitle: { html:"" },
        jobSubTitle: { html:"" },
        jobSubDesc: { html:"" },
        jobLocDesc: { html:"" },
        shareDesc: { html:"" },
        contactDesc: { html:"" },
        jobMainDesc: { html:"" },
        reqDesc: { html:"" },
        vacanciesDesc: { html:"" }
      } as Item,
      layout: "",
      loader: true,
      index:0,
      selectionOnMobile:false,
    };
  },
  methods: {
    setLocalSlug(jobID = '',jobRealID = ''){
      localStorage.setItem('slug',jobID);
      localStorage.setItem('clickedApply',jobRealID);
    },
    jobItemLinks(jobID = ''){
      return "/login/";
    },
    async clickedJobItem(referenceJobItem = '')
    {
      this.listLoader = true;
      this.selectedJobItem = referenceJobItem;
      //const newSelectedJobItem = this.jobs.find((job: Item) => job.id === referenceJobItem)
      const [newSelectedJobItem] = await this.$dataService.listJobs(referenceJobItem);
      if(newSelectedJobItem)
      {
        this.selectedJobDetails = newSelectedJobItem;
        if(this.selectedJobDetails.layout){
          this.layout = this.selectedJobDetails.description;
          this.loader=false;
        }else{
          this.useTemplate(this.selectedJobDetails.template.id)
        }
        console.log(this.layout)
      }
      this.listLoader = false;
    },
    selectsJobItem(referenceJobItem = '')
    {
      if(this.selectedJobItem === referenceJobItem)
      {
        return true;
      }
      else
      {
        return false;
      }
    },
    async updatePage(pageNumber:number,selectFirst=true) {
      this.listLoader = true;
      this.activePage = pageNumber;
      const jobsList = await this.$dataService.getJobsPartial(
        true,
        this.slug,
        this.perPage,
        this.activePage,
        this.selectedLocation,
      );
      const totalCounts = await jobsList.totalCounts;
      this.totalItemsForPages = totalCounts;
      this.jobs = jobsList.jobsList;
      console.log(this.jobs);
      if(this.userSigned)
      {
        //await this.verifyIfuserApplied();
      }
      if(selectFirst){
        this.selectFirstJobItem();
      }
      this.listLoader = false;
    },
    locationFilter(locationID:string) {
      this.selectedLocation = locationID;
      this.updatePage(this.activePage);
    },
    async getSignedUser() {
      if(await this.$dataService.verifyToken())
      {
        const userInfo = await this.$dataService.returnMe();
        this.user = userInfo;
        this.name = userInfo.firstName ?? '';
        this.email = userInfo.email ?? '';
        this.userSigned = true;
      }
    },
    async useTemplate(templateID:string) {
        const [jobProcessed] = await this.$dataService.listTemplateJobs(templateID);
        this.layout = jobProcessed.description;
        this.loader=false;
    },
    selectFirstJobItem(){
      if(this.jobs.length){
        const [firstJobListed] = this.jobs;
        this.clickedJobItem(firstJobListed.id);
      }
    },
    async shareJob(shareType='',slug=''){
      /*if(await this.$dataService.verifyToken())
      {
        this.shareType=shareType;
        this.shareResult='';
        this.shareLink = 'https://ramp.transparentbpo.com/careers/'+slug;
        this.shareLink.split("");
        this.shareModal = true;
      }
      else
      {
        this.$router.push('/login/'+slug);
      }
      */
      this.shareType=shareType;
      this.shareResult='';
      this.shareLink = 'https://ramp.transparentbpo.com/careers/'+slug;
      this.shareLink.split("");
      this.shareModal = true;
    },
    copyToClipboard()
    {
      const tempInput = document.createElement("input");
      tempInput.value = this.shareLink;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      this.shareResult = 'copied';
    },
    async sendToEmail()
    {
      this.emailLoader = true;
      let result = 'emailed';
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if(this.name === '') result = 'Please input name';
      if(!emailPattern.test(this.email)) result = 'Please input a valid e-mail';
      if(this.shareLink === '') result = 'Please selected a Job';
      if(this.selectedJobItem === '') result = 'Please selected a Job';
      if(result === 'emailed')
      {
        //Emailed
        const emailResult = await this.$dataService.shareJobViaEmail(this.name, this.email, this.shareLink, this.selectedJobItem);
        if(emailResult)
        {
          this.shareResult = result;
        }
        else
        {
          this.shareResult = 'Sending E-mail Failed!';
        }
      }
      else
      {
        this.shareResult = result;
      }
      this.emailLoader = false;
    }
  },
  async mounted() {
    if(this.$route.params.source!==undefined){
      localStorage.setItem('source',this.$route.params.source as string);
    }else{
      localStorage.setItem('source','Site');
    }
    if(this.$route.params.slug!==undefined)
    {
      this.slug = this.$route.params.slug as string;
      await this.updatePage(this.activePage);
      this.slug="";
    }
    this.locations = await this.$dataService.getTerritories();
    await this.getSignedUser();
    if(this.$route.params.locationName)
    {
      const locationName = this.$route.params.locationName as string;
      const filteredLocationID = await this.$dataService.returnTerritoryID(locationName);
      console.log("filteredLocationID",filteredLocationID)
      this.selectedLocation = filteredLocationID ?? 'all';
      console.log("this.selectedLocation",this.selectedLocation)
    }
    if(localStorage.getItem('locationFilter') !== null)
    {
      this.selectedLocation = localStorage.getItem('locationFilter') ?? 'all';
      localStorage.removeItem('locationFilter');
    }
    if(this.$route.params.slug!==undefined)
    {
      await this.updatePage(this.activePage,false);
    }else{
      await this.updatePage(this.activePage);
    }
    this.displayLoader = false;
    if(this.$route.params.slug!==undefined)
    {
      //
    }else{
      this.selectFirstJobItem();
    }
  },
});
</script>
<style>
ul {
    margin:auto;
    padding:revert;
}
ol {
    margin:auto;
    padding:revert;
}
</style>
<style scoped>
ul {
    margin: auto;
    padding: revert;
}
.shareButtons
{
  cursor:pointer;
}
.alreadyApplied
{
  position:absolute;
  top:6px;
  right:5px;
  font-size:12px;
}
.ramp-job-items
{
  cursor: pointer;
}
.ramp-job-items:hover
{
  cursor: pointer;
  border: 1px solid #54AFCB;
  background: rgba(84, 175, 203, 0.20);
  box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.25);
}
.ramp-job-items-active
{
  cursor: banned;
  border: 1px solid #54AFCB;
  background: rgba(84, 175, 203, 0.20);
  box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.25);
}
.ramp-job-new-tab
{
  font-size:12px;
  color:#54AFCB;
}
.ramp-job-shares
{
  font-size:10px;
  color:#54AFCB;
}
.ramp-job-title
{
  font-size:16px;
  font-weight: 700;
  opacity:1;
}
.ramp-job-description-content
{
  margin-top:15px;
  max-height:64px;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size:10px;
}
.ramp-job-description-main-content
{
  margin-top:25px;
  font-size:14px;
  overflow-y: auto; /* Enable vertical scrollbar */
  height:auto;
}
/* width */
::-webkit-scrollbar {
  width: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.ramp-job-description-main-content>p
{
  margin-top:15px;
}

.ramp-job-description-icons
{
  justify-content: space-between;
  font-size:10px;
}
.ramp-location-toggle
{
  background: #fff !important;
}
.ramp-location-toggle::v-deep .v-btn__overlay
{
  background: #fff !important;
}
.ramp-location-filter-items
{
  padding:5px !important;
}
.site-content-crowded
{
  padding-top:25;
  padding-bottom:25px;
}
.ramp-location-filter{
  background:#E6EAF2
}
.mobile-only{
  display:none;
}
@media only screen and (max-width: 600px) {
  .no-mobile{ display:none; }
  .ramp-job-description-main-content{ overflow:scroll;height:450px;margin-bottom:15px; }
  #main-content{ min-width:700px;min-height:400px; }
  .loc-btn{ font-size:12px;padding:5px;height:35px; }
  .v-btn-group--density-default.v-btn-group {
      height: 26px;
  }
  .mobile-only{
    display:block;
  }
}
</style>